module.exports = __webpack_public_path__ + "fonts/lato-black-greek.518c299.woff2";